/**
 * Orientation of the tabs / stepper navigation
 */
export var SubconfigurationNavigationOrientation;
(function (SubconfigurationNavigationOrientation) {
    SubconfigurationNavigationOrientation["Horizontal"] = "horizontal";
    SubconfigurationNavigationOrientation["Vertical"] = "vertical";
})(SubconfigurationNavigationOrientation || (SubconfigurationNavigationOrientation = {}));
/**
 * The primary navigation is displayed on the top or left side
 */
export var SubconfigurationNavigationControl;
(function (SubconfigurationNavigationControl) {
    SubconfigurationNavigationControl["Tabs"] = "tabs";
    SubconfigurationNavigationControl["Stepper"] = "stepper";
    SubconfigurationNavigationControl["None"] = "none";
})(SubconfigurationNavigationControl || (SubconfigurationNavigationControl = {}));
/**
 * The secondary control is display beween the tabs / stepper and the content
 */
export var SubconfigurationNavigationSecondaryControl;
(function (SubconfigurationNavigationSecondaryControl) {
    /**
     * Previous or next buttons
     */
    SubconfigurationNavigationSecondaryControl["Buttons"] = "buttons";
    SubconfigurationNavigationSecondaryControl["None"] = "none";
})(SubconfigurationNavigationSecondaryControl || (SubconfigurationNavigationSecondaryControl = {}));
export var SubconfigurationNavigationItemType;
(function (SubconfigurationNavigationItemType) {
    SubconfigurationNavigationItemType["Attribute"] = "ConfigurationAttribute";
    SubconfigurationNavigationItemType["Instance"] = "ConfigurationObject";
    SubconfigurationNavigationItemType["Group"] = "ConfigurationGroup";
})(SubconfigurationNavigationItemType || (SubconfigurationNavigationItemType = {}));
//# sourceMappingURL=SubconfigurationNavigationProps.js.map